/**
 * Token and credential storage.
 *
 * The web implementation is `localStorage`, which is *not* secure storage —
 * it is readable by any script on the origin. It is the best a browser offers
 * and the PWA build accepts that risk; the Capacitor build must replace this
 * with Keychain (iOS) / EncryptedSharedPreferences (Android) so the refresh
 * token is not sitting in the WebView's origin storage.
 */
export interface SecureStorage {
  get(key: string): Promise<string | null>
  set(key: string, value: string): Promise<void>
  remove(key: string): Promise<void>
}

const PREFIX = 'sx.'

export const webSecureStorage: SecureStorage = {
  async get(key) {
    try {
      return globalThis.localStorage?.getItem(PREFIX + key) ?? null
    } catch {
      return null
    }
  },
  async set(key, value) {
    try {
      globalThis.localStorage?.setItem(PREFIX + key, value)
    } catch {
      /* private mode, quota — treat as a session-only store */
    }
  },
  async remove(key) {
    try {
      globalThis.localStorage?.removeItem(PREFIX + key)
    } catch {
      /* ignore */
    }
  },
}
